import { useState } from 'react';
import PropTypes from 'prop-types';

import { DELAY_SLIDE_IN_BANNER_MOBILE } from 'app/config';
import { noop } from 'app/shared/utils/utils';
import { useInterval } from 'app/shared/hooks/useInterval';
import { sessionStore } from 'app/shared/utils/storageFactory';
import { useHasMounted } from 'app/shared/hooks/useHasMounted';

import { DesktopBanner } from './DesktopBanner/DesktopBanner';
import { MobileBanner } from './MobileBanner/MobileBanner';

const MOBILE_BANNER_DELAY = parseInt(DELAY_SLIDE_IN_BANNER_MOBILE, 10);
export const CrmBanner = ({
  onClose,
  onFormSubmit,
  threshold,
  areCookiesAccepted,
  setFormSubmitted,
  submitted,
  openOverlay,
  closeOverlay,
  isMobileVariant,
  isDesktopVariant,
  target,
}) => {
  const hasMounted = useHasMounted();
  const [done, setDone] = useState(false);

  const [sessionTime, setSessionTime] = useState(() => {
    if (hasMounted)
      return parseInt(
        sessionStore.getItem('crmSlideInBannerCounter') || '0',
        10,
      );
    return 0;
  });

  const visibleOnMobile = sessionTime * 1000 >= MOBILE_BANNER_DELAY;

  const [clearCallbackInterval] = useInterval(
    () => {
      setSessionTime((prevState) => {
        const newState = prevState + 1;
        sessionStore.setItem('crmSlideInBannerCounter', newState.toString());
        return newState;
      });
    },
    1000,
    isDesktopVariant || visibleOnMobile,
  );

  const finishSubmit = () => {
    setDone(true);
    setFormSubmitted(areCookiesAccepted);
  };

  if (visibleOnMobile && clearCallbackInterval) {
    clearCallbackInterval();
  }
  if (isMobileVariant && visibleOnMobile) {
    return (
      <MobileBanner
        openOverlay={openOverlay}
        closeOverlay={closeOverlay}
        onFormSubmit={onFormSubmit}
        finishSubmit={finishSubmit}
        onClose={onClose}
        done={done}
        areCookiesAccepted={areCookiesAccepted}
        threshold={threshold}
        submitted={submitted}
        target={target}
      />
    );
  }
  if (isDesktopVariant) {
    return (
      <DesktopBanner
        onFormSubmit={onFormSubmit}
        finishSubmit={finishSubmit}
        onClose={onClose}
        areCookiesAccepted={areCookiesAccepted}
        done={done}
        threshold={threshold}
        submitted={submitted}
      />
    );
  }

  return null;
};

CrmBanner.propTypes = {
  onClose: PropTypes.func,
  onFormSubmit: PropTypes.func,
  threshold: PropTypes.number.isRequired,
  areCookiesAccepted: PropTypes.bool,
  setFormSubmitted: PropTypes.func,
  submitted: PropTypes.bool,
  openOverlay: PropTypes.func,
  closeOverlay: PropTypes.func,
  isMobileVariant: PropTypes.bool,
  isDesktopVariant: PropTypes.bool,
  target: PropTypes.string.isRequired,
};

CrmBanner.defaultProps = {
  onClose: noop,
  onFormSubmit: noop,
  areCookiesAccepted: false,
  setFormSubmitted: noop,
  submitted: false,
  openOverlay: noop,
  closeOverlay: noop,
  isMobileVariant: false,
  isDesktopVariant: false,
};
